import { HttpMethod, httpClient } from './http-client';

export const getPrintLabel = (entityType: string, entityId: number) => {
  return httpClient(`/printLabel/${entityId}/entityType/${entityType}`, HttpMethod.Get, null);
};

export const getSignedMessage = (content: string) => {
  return httpClient('/printLabel/signMessage', HttpMethod.Post, { content });
};